import { FormatSizeIcon } from './FormatSizeIcon';

/**
 * author: Google
 * id 3F6E54F6-CF3E-46C8-BD72-A9BCF6DCF80C
 * name format-size
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-size.svg
 * tags
 * - Text / Content / Format 
 */
export const FontSizeIcon = FormatSizeIcon;
export default FontSizeIcon